import { useState, useEffect } from "react";
import t from "../../theme";

import PolicyModal from "../PolicyModal";
import AppModal from "../AppModal";
import AboutContent from "../../pages/About/AboutContent";
import FAQContent from "../../pages/Home/FAQ/FAQContent";
import { PRIVACY_POLICY_URL, TERMS_CONDITIONS_URL } from "../../constants";

const FOOTER_LINKS = [
  { modal: "about", label: "About" },
  { modal: "terms", label: "Terms & Conditions" },
  { modal: "privacy", label: "Privacy Policy" },
  { modal: "faq", label: "FAQ" },
];

const Footer1 = () => {
  const [mobileView, setMobileView] = useState(false);
  const [activeModal, setActiveModal] = useState(null);

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 767
        ? setMobileView(true)
        : setMobileView(false);
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  const renderLink = (link, linkStyle) => (
    <button
      key={link.label}
      type="button"
      onClick={() => setActiveModal(link.modal)}
      style={{
        ...linkStyle,
        background: "none",
        border: "none",
        padding: 0,
        font: "inherit",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => (e.target.style.color = "#2e7d32")}
      onMouseLeave={(e) => (e.target.style.color = t.text.secondary)}
    >
      {link.label}
    </button>
  );

  return (
    <>
      {!mobileView ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "auto",
          }}
        >
          <div style={{ flex: "1" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 32px",
                marginTop: "40px",
                color: t.text.secondary,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.82) 100%)",
                backdropFilter: t.blur.heavy,
                WebkitBackdropFilter: t.blur.heavy,
                borderTop: "1px solid rgba(46, 125, 50, 0.1)",
                boxShadow: "0 -2px 10px rgba(46, 125, 50, 0.05)",
                bottom: "0",
                width: "100%",
                zIndex: 1001,
                fontSize: "0.8rem",
              }}
            >
              <div style={{ fontWeight: 600, color: t.text.secondary }}>
                © Moneymail {new Date().getFullYear()}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "24px",
                }}
              >
                {FOOTER_LINKS.map((link) =>
                  renderLink(link, {
                    textDecoration: "none",
                    color: t.text.secondary,
                    fontWeight: 500,
                    fontSize: "0.8rem",
                    transition: "color 0.2s ease",
                  })
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "auto",
            }}
          >
            <div style={{ position: "relative" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "8px",
                  padding: "12px 16px",
                  marginTop: "40px",
                  color: t.text.secondary,
                  background:
                    "linear-gradient(135deg, rgba(255,255,255,0.82) 0%, rgba(255,255,255,0.72) 100%)",
                  backdropFilter: t.blur.heavy,
                  WebkitBackdropFilter: t.blur.heavy,
                  borderTop: "1px solid rgba(46, 125, 50, 0.1)",
                  boxShadow: "0 -2px 10px rgba(46, 125, 50, 0.05)",
                  fontSize: "0.78rem",
                }}
              >
                <div style={{ fontWeight: 500, color: t.text.muted }}>
                  © Moneymail {new Date().getFullYear()}
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "16px",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  {FOOTER_LINKS.map((link) =>
                    renderLink(link, {
                      textDecoration: "none",
                      color: t.text.secondary,
                      fontWeight: 500,
                      fontSize: "0.78rem",
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <PolicyModal
        open={activeModal === "privacy"}
        onClose={() => setActiveModal(null)}
        title="Privacy Policy"
        policyUrl={PRIVACY_POLICY_URL}
      />
      <PolicyModal
        open={activeModal === "terms"}
        onClose={() => setActiveModal(null)}
        title="Terms & Conditions"
        policyUrl={TERMS_CONDITIONS_URL}
      />
      <AppModal
        open={activeModal === "about"}
        onClose={() => setActiveModal(null)}
        maxWidth="800px"
      >
        <AboutContent />
      </AppModal>
      <AppModal
        open={activeModal === "faq"}
        onClose={() => setActiveModal(null)}
        maxWidth="800px"
      >
        <FAQContent />
      </AppModal>
    </>
  );
};

export default Footer1;
